import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'

import Box from '@mui/material/Box';

import Form from '../../Common/Form';
import ItemPicker from '../../Common/Form/ItemPicker';

import LocationList from '../../Location/LocationList';

const POSInitializeOrder = () => {

    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        originType: 'POS', // Work order origin type for POS transactions
    });

    // Setting initial data for the ItemPicker components
    const [location, setLocation] = useState({ name: '', id: null });


    // --- Handle input changes
    const handleChange = (e) => {
        console.log('Handling change event: ', e);
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };


    // Debug formData update
    useEffect(() => {
        console.debug('Form Data updated: ', formData);
    }, [formData])


    return (
        <Box sx={{ padding: 3, maxWidth: '600px', margin: 'auto' }}>
            <Form
                resourceName='Order'
                apiPath='/tenants/work-orders'
                formData={formData}
                requiredFields={
                    [
                        { name: 'locationId', label: 'Location' },
                    ]
                }
                editMode={false}
                submitText='Start POS Session'
                onSubmit={(workOrderData) => {
                    // Navigate to POS with work order ID
                    if (workOrderData.id) {
                        navigate(`/sales/pos/${workOrderData.id}`);
                    }
                    else {
                        navigate(`/sales/pos/start`);
                    }
                }}
                onCancel={() => {
                    navigate('/sales/invoices')
                }}
            >

                <ItemPicker
                    label="Location *"
                    name="locationId"
                    initialValue={location}
                    ListView={LocationList}
                    onChange={handleChange}
                />
            </Form>
        </Box>
    );
};

export default POSInitializeOrder;